import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Images } from "./Images";

const Services = ({ cmsLits }) => {



  // const [services, setServices] = useState([
  //   {
  //     icon: Images.analytics,
  //     name: "Data Analytics",
  //     active: false,
  //     des: "Unlock the power of data analytics with our flash loan arbitrage bot. Analyze trading patterns across Binance and Polygon networks in real-time. Gain actionable insights to maximize profit opportunities effortlessly. Make informed decisions with advanced metrics and precise trade execution.",
  //   },
  //   {
  //     icon: Images.training,
  //     name: "Training And Workshops",
  //     active: true,
  //     des: "Gain insights into automated and manual trading strategies tailored for real-world scenarios.",
  //   },
  //   {
  //     icon: Images.custom_design,
  //     name: "Custom Design",
  //     active: false,
  //     des: "Experience tailored solutions with our custom-designed flash loan arbitrage bot. Crafted to fit your unique trading needs across Binance and Polygon networks.  ",
  //   },
  //   {
  //     icon: Images.integration,
  //     name: "Integration",
  //     active: false,
  //     des: "Unlock seamless integration with our flash loan arbitrage bot! Learn to connect wallets, manage gas deposits, and enable automated trades across Binance and Polygon networks. ",
  //   },
  //   {
  //     icon: Images.development,
  //     name: "Custom Development",
  //     active: false,
  //     des: "Bring your vision to life with our custom flash loan arbitrage bot development! Tailored solutions for Binance and Polygon networks to match your unique trading needs. From subscription models to advanced automation, we design features just for you.",
  //   },
  //   {
  //     icon: Images.consulting,
  //     name: "Consulting",
  //     active: false,
  //     des: "Optimize your trading strategies with expert consultation for flash loan arbitrage bots! Get personalized guidance on integration, automation, and multi-network operations across Binance and Polygon.",
  //   },
  // ]);

  const [value1, setValue1] = useState()
  const [value2, setvalue2] = useState()
  const [value3, setvalue3] = useState()
  const [value4, setvalue4] = useState()
  const [value5, setvalue5] = useState()
  const [value6, setvalue6] = useState()
  const [value7, setvalue7] = useState()



  const [icon1, setIcon1] = useState(Images.analytics)
  const [icon2, setIcon2] = useState(Images.training)
  const [icon3, setIcon3] = useState(Images.custom_design)
  const [icon4, setIcon4] = useState(Images.integration)
  const [icon5, setIcon5] = useState(Images.development)
  const [icon6, setIcon6] = useState(Images.consulting)


  useEffect(() => {
    if (cmsLits) {
      setValue1(cmsLits.find((value) => (value.identifier == 'Services 1')))
      setvalue2(cmsLits.find((value) => (value.identifier == 'Services 2')))
      setvalue3(cmsLits.find((value) => (value.identifier == 'Services 3')))
      setvalue4(cmsLits.find((value) => (value.identifier == 'Services 4')))
      setvalue5(cmsLits.find((value) => (value.identifier == 'Services 5')))
      setvalue6(cmsLits.find((value) => (value.identifier == 'Services 6')))
      setvalue7(cmsLits.find((value) => (value.identifier == 'Highlights Services')))

    }
  }, [cmsLits]);



  return (
    <div className="services">
      <Container className="custom_container">
        <div className="header_sec">
          {/* <div className="d-flex align-items-center justify-content-center">
            <Button className="our_servicesBtn cmn_gradientBtn">
              <span>OUR SERVICES</span>
            </Button>
          </div> */}
          <Row className="mt-0">
            <Col xs={12} md={12} lg={11}>
              <p className="title-txt">
                {value7?.heading}
                {/* Highlights <span className="linear-txt">Services</span> */}
              </p>
              <p className="paracontent t-grey">
                {value7?.content}
              </p>
            </Col>
          </Row>
        </div>
        <div className="servicesrow gridbox">
          {/* {services.map((item, index) => {
            return (
              <div
                className="col-12 col-sm-6 col-lg-4 mb-4 mb-xl-5 hvr_col"
                key={index}
              >
                <div
                  className="service_card"
                >
                  <div className="title_card">
                    <img src={item.icon} className="img_src" />
                  </div>
                  <div className="content_sec">
                    <p className="title mb-0">{item.name}</p>
                    <p className="des mb-0">{item.des}</p>
                  </div>
                </div>
              </div>
            );
          })} */}


          <div
            // className="col-12 col-sm-6 col-lg-6 col-xl-4 mb-4"
            
            key={1}
          >
            <div
              className="service_card"
            >
              <div className="service_cardinner">
                <p className="title mb-0">{value1?.heading}</p>
                <div className="title_card">
                  <img src={icon1} className="img_src" />
                </div>
                <div className="content_sec">
                  <p className="des mb-0">{value1?.content}</p>
                </div>
              </div>
            </div>
          </div>


          <div
            
            key={2}
          >
            <div
              className="service_card"
            >
              <div className="service_cardinner">
                <p className="title mb-0">{value2?.heading}</p>
                <div className="title_card">
                  <img src={icon2} className="img_src" />
                </div>
                <div className="content_sec">
                  <p className="des mb-0">{value2?.content}</p>
                </div>
              </div>
            </div>
          </div>


          <div
            
            key={1}
          >
            <div
              className="service_card"
            >
              <div className="service_cardinner">
                <p className="title mb-0">{value3?.heading}</p>
                <div className="title_card">
                  <img src={icon3} className="img_src" />
                </div>
                <div className="content_sec">
                  <p className="des mb-0">{value3?.content}</p>
                </div>
              </div>
            </div>
          </div>


          <div
            
            key={1}
          >
            <div
              className="service_card"
            >
              <div className="service_cardinner">
                <p className="title mb-0">{value4?.heading}</p>
                <div className="title_card">
                  <img src={icon4} className="img_src" />
                </div>
                <div className="content_sec">
                  <p className="des mb-0">{value4?.content}</p>
                </div>
              </div>
            </div>
          </div>

          <div
            
            key={1}
          >
            <div
              className="service_card"
            >
              <div className="service_cardinner">
                <p className="title mb-0">{value5?.heading}</p>
                <div className="title_card">
                  <img src={icon5} className="img_src" />
                </div>
                <div className="content_sec">
                  <p className="des mb-0">{value5?.content}</p>
                </div>
              </div>
            </div>
          </div>

          <div
            
            key={1}
          >
            <div
              className="service_card"
            >
              <div className="service_cardinner">
                <p className="title mb-0">{value6?.heading}</p>
                <div className="title_card">
                  <img src={icon6} className="img_src" />
                </div>
                <div className="content_sec">
                  <p className="des mb-0">{value6?.content}</p>
                </div>
              </div>
            </div>
          </div>


        </div>
      </Container>
    </div>
  );
};

export default Services;
